import React from 'react';
export function TrustBar() {
  const trustPoints = ['Free In-Home Estimates', 'Broken Window Repair', 'Foggy Double-Pane Glass', 'Glass-Only Replacement', 'Door Glass Replacement', 'Custom Mirrors & Shower Glass', 'Warranty-Backed Work', 'Competitive Pricing', 'Howell, Ann Arbor & Novi', 'Same-Day Openings May Be Available'];
  return <div className="bg-navy-900 py-6 px-4 sm:px-6 lg:px-8 border-t border-navy-800" data-id="element-215">
      <div className="max-w-7xl mx-auto" data-id="element-216">
        <div className="flex flex-wrap justify-center gap-3 md:gap-4" data-id="element-217">
          {trustPoints.map((point, idx) => <span key={idx} className="inline-flex items-center px-3 py-1.5 rounded-full bg-navy-800 text-slate-200 text-sm font-medium border border-navy-700 whitespace-nowrap" data-id="element-218">
              {point}
            </span>)}
        </div>
      </div>
    </div>;
}